import { styled } from '@mui/material';
import _groupBy from 'lodash/groupBy';
import _isNil from 'lodash/isNil';
import _orderBy from 'lodash/orderBy';
import React from 'react';
import QcSymbology from '@Views/QualityControl/styles/symbology.scss';
import { ICircleObjectProps } from '../PlanView';
import { getCoordinatesOfPointOnCircle } from '../helpers';

const PerpendicularLine = styled('line')`
    transform-box: fill-box;
    transform-origin: center;
    transform: rotate(90deg);
`;

export const Anchor = (props: ICircleObjectProps) => {
    const anchorRadius = props.circleRadius / 3;
    const anchorWidth = anchorRadius / 4;
    const offsetLength = anchorWidth / 2;

    const linePosition = getCoordinatesOfPointOnCircle(
        anchorRadius,
        props.bearing,
        {
            x: props.circleCenter,
            y: props.circleCenter,
        }
    );

    const pStart = getCoordinatesOfPointOnCircle(
        anchorRadius + offsetLength,
        props.bearing,
        {
            x: props.circleCenter,
            y: props.circleCenter,
        }
    );

    const perpendicularLine = getCoordinatesOfPointOnCircle(
        anchorWidth,
        props.bearing + Math.PI,
        pStart
    );

    return (
        <svg>
            <line
                x1={props.circleCenter}
                y1={props.circleCenter}
                x2={linePosition.x}
                y2={linePosition.y}
                stroke={QcSymbology.anchor}
            />

            <PerpendicularLine
                x1={pStart.x}
                y1={pStart.y}
                x2={perpendicularLine.x}
                y2={perpendicularLine.y}
                stroke={QcSymbology.anchor}
            />
        </svg>
    );
};
